import { TabContentProps } from './model';
import { View } from './view';

export const TabContent = (props: TabContentProps) => {
    if (props.currentTabIndex !== props.index) return null;

    return View(props);
};
